function historyState() {
  return window.history && window.history.replaceState;
}

function getParam(name) {
  if ('URLSearchParams' in window) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  } else {
    var params = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (params == null) {
      return null;
    } else {
      return decodeURI(params[1]) || 0;
    }
  }
}

var Shopify = Shopify || {};
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Toggle mobile nav – global
function toggleNav() {
  let nav = document.querySelector('#header-nav');
  if (!nav) return;
  nav.classList.toggle('nav-open');
}

// Number input stepper – scoped to a root
function handleNumberStepper(root) {
  const scope = root || document;
  let maxQty = 20;
  let minQty = 1;
  const steppers = scope.querySelectorAll('.input-stepper');

  steppers.forEach(function (stepper) {
    let input = stepper.querySelector('input[type="number"]');
    if (!input) return;

    let stepperButtons = stepper.querySelectorAll('button');
    let maxValue =
      input.getAttribute('max') !== null ? parseInt(input.getAttribute('max'), 10) : maxQty;
    let minValue =
      input.getAttribute('min') !== null ? parseInt(input.getAttribute('min'), 10) : minQty;

    stepperButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        let currentValue = parseInt(input.value, 10) || 0;
        if (button.classList.contains('input-stepper_decrease')) {
          if (currentValue > minValue) {
            input.value = String(currentValue - 1);
          }
        }
        if (button.classList.contains('input-stepper_increase')) {
          if (currentValue < maxValue) {
            input.value = String(currentValue + 1);
          }
        }
      });
    });
  });
}

// Close nav dropdowns – global; 
let navDropdownsBound = false;
function handleCloseDropdownMenus() {
  if (navDropdownsBound) return;
  navDropdownsBound = true;

  const nav = document.querySelector('#header-nav');
  if (!nav) return;

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      // Close dropdown menus
      nav.querySelectorAll('details[open]').forEach((detail) => {
        detail.removeAttribute('open');
      });
      // Toggle nav if it's open, but not on index template
      const isIndexTemplate = nav.getAttribute('data-template') === 'index';
      if (nav.classList.contains('nav-open') && !isIndexTemplate) {
        toggleNav();
      }
    }
  });
}

// Nav toggles – global; 
let navTogglesBound = false;
function handleNavToggles() {
  if (navTogglesBound) return;
  navTogglesBound = true;

  const nav = document.getElementById('header-nav');
  if (!nav) return;

  let details = nav.querySelectorAll('details');
  details.forEach(function (detail) {
    detail.addEventListener('toggle', function () {
      if (detail.open) {
        details.forEach((otherDetail) => {
          if (otherDetail !== detail && otherDetail.open) {
            otherDetail.open = false;
          }
        });
      }
    });
  });
}

// SPA- and non-SPA-friendly initializer
window.Theme = window.Theme || {};
window.Theme.init = function initTheme(root) {
  const scope = root || document;

  // Scoped behaviors (inside main content)
  handleNumberStepper(scope);

  // Global header/nav behaviors
  handleCloseDropdownMenus();
  handleNavToggles();
};

// Non-SPA fallback: run once on DOM ready
(function () {
  if (document.readyState !== 'loading') {
    window.Theme.init(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      window.Theme.init(document);
    });
  }
})();